/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mChatVoice.vue?vue&type=template&id=77a7a36a"
import script from "./mChatVoice.vue?vue&type=script&lang=js"
export * from "./mChatVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports